// extracted by mini-css-extract-plugin
export default {"heroSlider":"PageBuilderHero-module-heroSlider-3Fo","sliderWrapper":"PageBuilderHero-module-sliderWrapper-1Zv"};